<template>
  <v-layout>
    <v-flex xs12>
      <v-card class="registration-wrap pa-4 mb-5">
        <v-alert
            color="error"
            class="err"
            icon="warning"
            value="true"
            v-if="err">
          <v-layout column>
            <p class="mb-2">{{err}}</p>
            <div v-if="err === 'User:Register failed. Account found with same email'">
              <v-btn
                  class="mx-0"
                  @click.stop.prevent="$router.push({ name: 'forgotPassword', query: { email } })">
                Reset password
              </v-btn>
            </div>
            <div v-if="err === 'User:Register failed. Account found with same phone'">
              <v-btn
                  class="mx-0"
                  @click.stop.prevent="$router.push({ name: 'forgotPassword', query: { phone } })">
                Reset password
              </v-btn>
            </div>
          </v-layout>
        </v-alert>
        <v-form v-model="valid" @submit.native.prevent="registerUser()">
          <v-flex xs12>
            <v-text-field
                :label="$lang.labels.name"
                v-model="name"
                name="name"
                :rules="nameRules"
                required
            ></v-text-field>
            <v-text-field
                :label="$lang.labels.email"
                v-model="email"
                name="email"
                :rules="emailRules"
                required
            ></v-text-field>
            <v-text-field
                :label="$lang.labels.phone"
                v-model="phone"
                name="phone"
                :rules="[phoneNumberRules]"
                required
            ></v-text-field>
          </v-flex>
          <v-layout row class="agreement text-xs-left">
            <v-checkbox v-model="checkbox" style="max-width: 20px"/>
            <p class="pl-2 text-xs-left">{{$lang.header.iAgree1}} <a @click.stop="inNewTab('terms')">{{$lang.header.tearmsConditions}}</a> {{$lang.header.and}} <a @click.stop="inNewTab('data-protection')">{{$lang.header.cookiePrivacy}}</a></p>
          </v-layout>
          <v-btn
              color="primary"
              type=submit
              class="ma-0">{{$lang.actions.submit}}</v-btn>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        name: '',
        email: this.$route.query.email || '',
        phone: '',
        checkbox: false,
        valid: false,
        nameRules: [
          v => !!v || this.$lang.errors.nameMustHaveCharacters,
          v => (v && v.length <= 35) || this.$lang.errors.nameLess,
        ],
        emailRules: [
          v => !!v || this.$lang.errors.requiredEmail,
          // eslint-disable-next-line
          v => (v && /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v.toLowerCase())) || this.$lang.errors.notValidEmail,
        ],
        err: '',
      };
    },
    computed: {
      ...mapGetters({
        company: 'company',
      }),
      phoneNumberRules() {
        if (this.company && (this.phone || this.phone !== '')) {
          return this.testPhoneNumberRules(this.company.address.country, this.phone);
        }
        return this.$lang.errors.requiredPhone;
      },
    },
    methods: {
      testPhoneNumberRules(country, phone) {
        if (!phone) return this.$lang.errors.requiredPhone;
        if (!country) return this.$lang.errors.countryRequired;
        if (country === 'UK') {
          return ([10, 11].includes(phone.replace(/\+|-|_|\/|(|)/g, '').length) &&
                  /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,3}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/.test(phone)) || this.$lang.errors.notValidPhone;
        }
        if (country === 'AT') {
          let tempPhone = phone.replace(/\+|-|_| |\/|(|)/g, '');
          if (tempPhone.substring(0, 2) === '00') {
            tempPhone = tempPhone.substring(2, tempPhone.length);
          }
          if (tempPhone.substring(0, 2) === '43') {
            tempPhone = `0${tempPhone.substring(2, tempPhone.length)}`;
          }
          let checkPhone = /^0(6[045679][0469]){1}(-)?(1)?[^0\D]{1}\d{6,7}$/.test(tempPhone);
          if (!checkPhone) {
            checkPhone = /^[0-9]*$/.test(tempPhone) && [8, 9, 10, 11, 12, 13].includes(tempPhone.length);
          }
          return checkPhone || this.$lang.errors.notValidPhone;
        }
        return this.$lang.errors.countryUnsupported;
      },
      inNewTab(name) {
        const routeData = this.$router.resolve({ name, params: { lang: this.$lang.current_lang } });
        window.open(routeData.href, '_blank');
      },
      registerUser() {
        this.err = '';
        if (!this.valid) {
          if (!this.email || !this.phone || !this.name) {
            this.err = this.$lang.errors.enterData;
          }
          return;
        }
        if (!this.checkbox) {
          this.err = this.$lang.errors.acceptPolicy;
          return;
        }
        this.$webHelper.post(
          'user/register',
          {
            phone: this.phone,
            name: this.name,
            userName: this.email,
            language: this.$lang.current_lang,
          },
          this.$router,
        ).then((res) => {
          if (!res.success) {
            this.err = res.body.statusText || this.$lang.errors.failedRegistration;
            return;
          }
          this.$router.push({ name: 'webShop', query: { registered: true } });
        });
      },
    },
  };
</script>

<style lang="scss" scoped>
  .h-100 {
    height: 100vh;
  }
  .registration-wrap {
    margin: 0 auto;
    min-width: 300px;
    max-width: 600px;
  }
  .agreement {
    p {
      margin-top: 6px;
    }
    .input-group {
      flex: 0 0;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/webshop/Registration.vue